import { compose } from 'recompose';
import { addProps } from 'utils/recompose';

const designOptions = ({ mini, primaryOptions, secondaryOptions }) => {
  if (mini) return [...primaryOptions, ...secondaryOptions];
  return ['paintOption', 'interiorOption', 'trimOption', 'wheelOption'];
};

export default compose(
  addProps({
    designOptions,
  }),
);
